import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/umami";

export function FinalCTA() {
  const { t } = useTranslation("landing");

  return (
    <section className="mx-auto max-w-[1200px] px-5 pt-24 md:px-10 md:pt-32">
      <div className="relative overflow-hidden rounded-3xl px-7 py-12 bg-mesh md:px-14 md:py-16">
        <div className="relative flex flex-col items-start gap-8">
          <div className="max-w-[560px]">
            <h2 className="text-4xl leading-[1.05] font-bold tracking-[-0.04em] text-white md:text-5xl">
              {t("finalCTA.title")}
            </h2>
            <p className="mt-4 text-[17px] text-[#d5deea]">{t("finalCTA.subtitle")}</p>
          </div>
          <Button asChild size="lg" className="shadow-primary">
            <Link
              to="/signup"
              onClick={() => trackEvent("signup_cta_click", { location: "final_cta" })}
            >
              {t("finalCTA.cta")}
              <ArrowRight />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
